import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'sharedComponents/Icon';
import SecondaryNav from 'sharedComponents/SecondaryNav';
import SocialButtons from 'sharedComponents/SocialButtons';
import { useTranslation } from 'react-i18next';

import { Link as RouterLink, useLocation } from 'react-router-dom';
import { List, ListItem, Link, IconButton, Drawer } from '@material-ui/core';

import clsx from 'clsx';

import { GET_ENUMS } from 'const/router';
import { appRoutes, externalRoutes } from 'routes';

import useStyles from './useStyles';

const NAVIGATION_ITEMS_MOBILE = [
  {
    label: 'components.MobileNonAuthHeader.SideBar.compare',
    MuiComponent: Link,
    href: 'https://bundleloan.com/blog/compare-current-mortgage-rates/',
    target: '_blank',
  },
  {
    label: 'components.MobileNonAuthHeader.SideBar.quiz',
    to: appRoutes.quizPath(),
    MuiComponent: Link,
    targetComponent: RouterLink,
  },
  {
    label: 'components.MobileNonAuthHeader.SideBar.mortgageCalculators',
    to: appRoutes.calculatorsPath(),
    MuiComponent: Link,
    targetComponent: RouterLink,
  },
];

const SideBar = props => {
  const { isOpen, onClose, isBuyerLocation } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const { pathname } = useLocation();

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      classes={{ paper: classes.panel, backdrop: classes.backdrop, modal: classes.menu }}
    >
      <div className={classes.topBar}>
        <IconButton onClick={onClose}>
          <Icon name="logo" width="100" />
        </IconButton>
        <IconButton onClick={onClose}>
          <Icon name="bigClose" />
        </IconButton>
      </div>
      <div className={classes.content}>
        <List className={classes.nav}>
          <ListItem className={clsx(classes.navItem, classes.topItem)}>
            {isBuyerLocation ? (
              <Link
                to={appRoutes.surveyPath()}
                component={RouterLink}
                className={classes.topItemLink}
                onClick={onClose}
              >
                {t('components.MobileNonAuthHeader.SideBar.getStarted')}
              </Link>
            ) : (
              <Link
                href={externalRoutes.requestDemoPath()}
                target="_blank"
                component={Link}
                className={classes.topItemLink}
              >
                {t('components.MobileNonAuthHeader.SideBar.scheduleDemo')}
              </Link>
            )}
          </ListItem>
          <ListItem className={clsx(classes.navItem, classes.topItem)}>
            <Link
              className={clsx(classes.topItemLink, classes.topItemLinkSecondary)}
              component={RouterLink}
              to={{ pathname, search: `?popup=${GET_ENUMS.popup.login}` }}
            >
              {t('components.MobileNonAuthHeader.SideBar.logIn')}
            </Link>
          </ListItem>
          {NAVIGATION_ITEMS_MOBILE.filter(({ to }) => to !== pathname).map(
            ({ label, to, href, target, MuiComponent, targetComponent }) => (
              <ListItem key={label} className={classes.navItem}>
                <MuiComponent
                  className={classes.navLink}
                  component={targetComponent}
                  to={to}
                  href={href}
                  target={target}
                  onClick={onClose}
                >
                  {t(label)}
                </MuiComponent>
              </ListItem>
            ),
          )}
        </List>
        <SecondaryNav onClose={onClose} />
        <div className={classes.socialButtons}>
          <SocialButtons />
        </div>
      </div>
    </Drawer>
  );
};

SideBar.propTypes = {
  isBuyerLocation: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SideBar;



// WEBPACK FOOTER //
// ./src/sharedComponents/MobileNonAuthHeader/components/SideBar/SideBar.js